import { styled } from "../../styled-components";
import Img from "../smart/img/img";
import { initialsBackground, initialsFontColor } from "../../lib/theme/theme";

export const GalleryImg = styled(Img)`
    background-color: ${p => p.theme.skeletonColor};

    width: 100%;
    height: 100%;
    object-fit: cover;

    // Emoji
    font-size: 50px;
`;

export const GalleryItemInitials = styled.div`
    background-color: ${p => initialsBackground(p.theme)};
    color: ${p => initialsFontColor(p.theme)};

    display: flex;
    justify-content: center;
    align-items: center;

    line-height: 36px;
    font-size: 34px;
    text-align: center;
    font-weight: bold;

    padding: 20px;

    width: 100%;
    height: 100%;
`;
